import { css } from 'lit';

export const StyleForLHAppHeader = css`
:host(.section-changing) #sections-wrapper {
  user-select: none;
}
#sections-wrapper {
  position: relative;
  transition: transform 550ms var(--transition-page);
  color: var(--c-header-text-not-selected);
}
#sections {
  display: flex;
  justify-content: space-evenly;
  position: relative;
  inset-inline-start: 0;
  transition: 550ms var(--transition-page);
  transform-origin: 50% 50%;
}
.section-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 6rem;
  justify-content: space-between;
  font-size: 1.5rem;
}
.icon-whatsapp,
.section-summary-icon {
  color: var(--c-emphasize-rev);
}
.section-summary-icon > svg {
  width: 2rem;
  height: auto;
}
.section-icon {
  position: relative;
  z-index: 1;
}
arc-progress {
  position: absolute;
  top: -6px;
  right: -6px;
  color: var(--c-select-rev);
}
.section-label{
  color: var(--c-header-text-not-selected);
}
.section-label.section-active{
  color: var(--c-header-text-selected);
}
#artline-wrapper {
  position: absolute;
  text-align: center;
  display: inline-block;
  left: var(--artline-wrapper-left);
  width: var(--artline-wrapper-width);
  right: var(--artline-wrapper-right);
  top: var(--artline-wrapper-top);
  height: var(--artline-wrapper-height);
  margin: var(--artline-wrapper-margin);
}
.artline {
  position: relative;
  height: 8rem;
  width: 100%;
  top: -3.5rem;
}
.section-icon:not(.section-summary-icon) {
  display: inline-block;
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  border: 0.375rem solid var(--c-border-normal);
  box-sizing: border-box;
  background: white;
}
.icon-check {
  width: 100%;
  position: absolute;
  top: 15%;
  height: 65%;
  color: var(--c-emphasize-rev);
}
.icon-boat {
  transform: rotate(90deg);
  width: 2rem;
}
:host([keyboard-open]) #boat-container,
:host([resizing]) #boat-container {
  transition: none;
}
#boat-container {
  top: -20px;
  left: -2.5em;
  border-radius: 50%;
  border: 5px solid #fff;
  position: absolute;
  z-index: 5;
  transition: transform 650ms var(--transition-page) 400ms;
  display: inline-grid;
  align-content: center;
  justify-content: center;
}
.hidden {
  display: none !important;
}
`;